/* Карточка заказа: статусы с защитой переходов, услуги, скидка не ниже мин. цены,
   депозит и оплата (касса и онлайн-ссылка), возврат по правилу отмены, история. */
import { SOURCE, totals, type OrderStatus } from "@okno/shared";
import { errorText } from "../../lib/api";
import { useSession } from "../../lib/session";
import type { OrderDetails } from "../../lib/types";
import { Icon } from "../../ui/Icon";
import { Drawer } from "../../ui/layers";
import { Empty, Spinner, StatusPill } from "../../ui/kit";
import { OrderFoot } from "./OrderFoot";
import { ClientSection, CommentSection, DiscountSection, HistorySection, ServicesSection, TimeBaySection, TotalsSection } from "./OrderSections";
import { PaymentsSection } from "./PaymentsSection";
import { CLOSED, useOrderDetails } from "./useOrder";

export function OrderDrawer({ orderId }: { orderId: string }) {
  const q = useOrderDetails(orderId);
  if (q.isLoading) {
    return (
      <Drawer title="Заказ">
        <Spinner />
      </Drawer>
    );
  }
  if (!q.data) {
    return (
      <Drawer title="Заказ">
        <Empty icon="alert" title="Заказ не найден" text={q.error ? errorText(q.error) : undefined} />
      </Drawer>
    );
  }
  return <OrderView details={q.data} />;
}

function OrderView({ details }: { details: OrderDetails }) {
  const { order: o, customer, vehicle, offer } = details;
  const { boot, can } = useSession();
  const t = totals(o, boot.settings);
  const closed = CLOSED.includes(o.status);
  const booking = can("booking");
  const editable = booking && !closed && o.status !== "ready";
  const title = "Заказ №" + o.num;

  return (
    <Drawer
      title={title}
      label={title}
      sub={
        <>
          <StatusPill status={o.status as OrderStatus} />
          <span style={{ marginLeft: 6 }}>{SOURCE[o.source]}</span>
        </>
      }
      foot={<OrderFoot order={o} />}
    >
      <ClientSection customer={customer} vehicle={vehicle} offer={offer} />
      <TimeBaySection order={o} editable={editable} canAssign={booking && !closed} />
      <ServicesSection order={o} vehicle={vehicle} editable={editable} />
      {editable && can("discount") ? <DiscountSection order={o} t={t} /> : null}
      <TotalsSection t={t} />
      <PaymentsSection order={o} t={t} />
      {o.cancelReason ? (
        <div className="callout callout-bad">
          <Icon name="info" size={16} />
          <span>Причина: {o.cancelReason}</span>
        </div>
      ) : null}
      <CommentSection order={o} disabled={closed || !booking} />
      <HistorySection order={o} />
    </Drawer>
  );
}
